// extracted by mini-css-extract-plugin
export default {"container":"WideHeading_container__JtQkP","wrapper":"WideHeading_wrapper__QiNqx","title":"WideHeading_title__8WhCR"};